const TRACKING_URLS = {
  FEDEX: "https://www.fedex.com/fedextrack/?trknbr=",
  HERMES: "https://www.myhermes.de/empfangen/sendungsverfolgung/?trackingId=",
  UPS: "https://www.ups.com/track?loc=tr_TR&tracknum=",
  GLS: "https://www.gls-pakete.de/en/parcel-tracking?trackingNumber=",
  DPD: "https://tracking.dpd.de/status/en_NL/parcel/",
  ROYAL_MAIL: "https://www.royalmail.com/track-your-item#/tracking-results/",
  DHL: "https://www.dhl.com/tr-tr/home/tracking.html?tracking-id=",
  DHL_ECO: "https://www.dhl.com/tr-tr/home/tracking/tracking-ecommerce.html?submit=1&tracking-id=",
  USPS: "https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=",
  TNT: "https://www.tnt.com/express/tr_tr/site/shipping-tools/tracking.html?searchType=con&cons=",
};

const normalizeCargoName = (cargoName) =>
  String(cargoName || "")
    .trim()
    .toLocaleUpperCase("tr-TR")
    .replace(/\s+/g, " ");

const getTrackingBaseUrl = (cargoName) => {
  const normalizedCargoName = normalizeCargoName(cargoName);

  if (normalizedCargoName.includes("UPS")) return TRACKING_URLS.UPS;

  if (normalizedCargoName.includes("DHL")) {
    const isEcoService = normalizedCargoName.includes("ECO") || normalizedCargoName.includes("EKO");
    return isEcoService ? TRACKING_URLS.DHL_ECO : TRACKING_URLS.DHL;
  }

  if (normalizedCargoName.includes("FEDEX")) return TRACKING_URLS.FEDEX;
  if (normalizedCargoName.startsWith("ROYAL MAIL")) return TRACKING_URLS.ROYAL_MAIL;
  if (normalizedCargoName.includes("HERMES")) return TRACKING_URLS.HERMES;
  if (normalizedCargoName.includes("GLS")) return TRACKING_URLS.GLS;
  if (normalizedCargoName.includes("DPD")) return TRACKING_URLS.DPD;
  if (normalizedCargoName.includes("USPS")) return TRACKING_URLS.USPS;
  if (normalizedCargoName.includes("TNT")) return TRACKING_URLS.TNT;

  return null;
};

export const getTrackingUrl = (cargoName, trackingNumber) => {
  const baseUrl = getTrackingBaseUrl(cargoName);
  const normalizedTrackingNumber = String(trackingNumber || "").trim();

  if (!baseUrl || !normalizedTrackingNumber) return null;

  return `${baseUrl}${encodeURIComponent(normalizedTrackingNumber)}`;
};
